import styled, { css } from 'styled-components'

import { themeStyles } from '../../../styles/theme'

export const StyledTooltip = styled.div`
  position: absolute;
  display: inline-block;
  cursor: pointer;

  ${({ top }) =>
    top &&
    css`
      top: ${top};
    `}

  ${({ right }) =>
    right &&
    css`
      right: ${right};
    `}

  &:hover span {
    visibility: visible;
    opacity: 1;
  }
`

export const TooltipText = styled.span`
  background-color: ${themeStyles.colors.darkGreys[5].main};
  border-radius: 6px;
  color: ${themeStyles.colors.white.main};
  opacity: 0;
  padding: 5px;
  position: absolute;
  z-index: 1999999;
  text-align: center;
  transition: opacity 0.3s;
  visibility: hidden;
  max-width: 20em;
  width: max-content;
  height: min-content;
  max-height: 20em;
`
